import guide1 from "assets/guides/11 6.png";
import guide2 from "assets/guides/22copy 1.png";
import guide4 from "assets/guides/33 2.png";
import guide6 from "assets/guides/55 copy 2.png";
import guide3 from "assets/guides/66 2.png";
import guide8 from "assets/guides/77 2.png";
import guide5 from "assets/guides/1111 1.png";
import guide7 from "assets/guides/2222 1.png";
import guide9 from "assets/guides/2222222 1.png";
import React from "react";

const Slider = ({ activeIndex }) => {
  const images = [
    guide1,
    guide2,
    guide3,
    guide4,
    guide5,
    guide6,
    guide7,
    guide8,
    guide9,
  ];
  return (
    <div className="relative max-w-[284px] z-10">
      <img
        alt=""
        src={images[activeIndex % images.length]}
        className="z-0 w-full"
      />
    </div>
  );
};

export default Slider;
